import React, { useState, useEffect } from 'react';

import styled from 'styled-components';
import i18next from 'i18next';

import SpeechSpeedSetter from './SpeechSpeedSetter';
import LanguageSelect from './LanguageSelect';
import MenSelect from './MenSelect';

import TextToSpeech from './TextToSpeech';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { DEFAULTS } from './appEnums';
import './App.css';
import './popup.css';
import {NavbarTwoColumns} from './NavbarTwoColumns.tsx'
import * as Loader from "react-loader-spinner";

const App = ({className}) => {

  const [isLoading, setIsLoading] = useState(false);

  i18next.init({
    lng: 'en',
    resources: {
      en: {
        translation: {
          "Click To Speech":
          "Click To Speech",
          "Language Select":
          "Language Select",
          "Please choose output language":
          "Please choose output language",
          "Male or Female":
          "Male or Female",
          "Please choose Male or Female":
          "Please choose Male or Female",
          "Male": "Male",
          "Female":"Female",
          "Text to speech":
          "Text to speech",
          "لطفاً ابتدا وارد شوید":
          "Please Login First!",
          'با انتخاب ورود به پنل، در بالا سمت راست، به صفحه ورود و یا ثبت نام وارد می شوید':
          'By clicking on Panel button at top right, you will enter login/register page.',
          'بازگشت':'Return',
          'ورود به پنل کاربری':'Panel'
        },
      },
      fa: {
        translation: {
          "Click To Speech":
            'برای صحبت کردن، کلیک کنید',
            "Language Select":
            "انتخاب زبان",
            "Please choose output language":
            "لطفاً زبان نوشته را انتخاب کنید",
            "Male or Female":
          "صدای آقا یا خانم",
          "Please choose Male or Female":
          "لطفاً آقا یا خانم را انتخاب کنید",
          "Male": "آقا",
          "Female":"خانم",
          "Text to speech":
          "متن به گفتار",
          "لطفاً ابتدا وارد شوید":
          "لطفاً ابتدا وارد شوید",
          'با انتخاب ورود به پنل، در بالا سمت راست، به صفحه ورود و یا ثبت نام وارد می شوید':
          'با انتخاب ورود به پنل، در بالا سمت راست، به صفحه ورود و یا ثبت نام وارد می شوید',
          'بازگشت':'بازگشت',
          'ورود به پنل کاربری':'ورود به پنل کاربری'
        },
      },
    },
  });
  
  const getCookieBase = (NameOfCookie) => {
    if (typeof window !== 'undefined') {
      if (document.cookie.length > 0) {
        let begin = document.cookie.indexOf(`${NameOfCookie}=`);
        if (begin !== -1) {
          begin += NameOfCookie.length + 1;
          let end = document.cookie.indexOf(';', begin);
          if (end === -1) end = document.cookie.length;
          return document.cookie.substring(begin, end);
        }
      }
    }
    return '';
  };
  const getCookie = (name) => {
    let cookie = getCookieBase('config');
    if (cookie === '') {
      cookie = {};
    } else cookie = JSON.parse(cookie);

    if (cookie[name] !== undefined) return cookie[name];
    return null;
  };
  const langcode = getCookie('language') ? getCookie('language') : 'fa';

  i18next.changeLanguage(langcode);

  const isRtl = i18next.language === "fa" ? true : false;
  React.useLayoutEffect(() => {
    document.body.setAttribute("dir", isRtl ? "rtl" : "ltr");
  }, [isRtl]);

  const [language, setLanguage] = useState(DEFAULTS.LANGUAGES);
  const [mf, setMf] = useState(DEFAULTS.MALEFEMALE);
  const [text, setText] = useState(DEFAULTS.TEXT);
  const initialState = {
    mosavverData:
      typeof window !== 'undefined'
        ? window.localStorage.getItem('mosavverData')
        : false,
  };
  useEffect(() => {
    if (initialState.mosavverData == null) {
      document.location.href = '#popup1';
    }
  }, [initialState.mosavverData]);

  let token = "";
  if(JSON.parse(initialState.mosavverData))
    token = JSON.parse(initialState.mosavverData).accessToken;
  const handleClick = async () => {
    console.log(token)
    if(!token)
    document.location.href = '#popup1';
    const unit = i18next.language === 'fa' ? 'toman' : 'usd';
    const API_URL = 'https://api.mosavver.com/chpt/';
    const lang = language;
    const maleFem = mf;
    setIsLoading(true);
    const response = await fetch(`${API_URL}get-prompt-result-tts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        prompt: text,
        unit,
        lang,
        maleFem
      }),
    });
    setIsLoading(false);

    if (!response.ok) {
      const errMsg = await response.text();
      if (errMsg.includes('Refresh token invalid or expired')) {
        if (typeof window !== 'undefined') {
          window.localStorage.removeItem('mosavverData');
          document.location.href = '#popup1';
        }
      }
      if (
        errMsg.includes('Insufficient Credit.') ||
        errMsg.includes('Balance is lower than minimum requirements (120T)')
      ) {
      }
console.log(errMsg)
      return;
    }

    let responseText = await response.text();
    var snd = new Audio("data:audio/wav;base64," + responseText);
    snd.play();

    snd.controls = true;
    document.body.appendChild(snd);
  };
  let style = {}
  if(i18next.language === "fa") {
    style = {fontFamily: 'BYekan'}
  } else {
  }
  return (
    <div className={className} style={style}>
      <NavbarTwoColumns
        logo={
          <>
            <Button
              onClick={() => {
                document.location.href =
                  getCookie('language') === 'fa' ? '/chatgpt' : `/chatgpt`;
              }}
              style={i18next.language === "fa" ? {fontFamily:"BYekan"}: {}}
            >
              {i18next.t('بازگشت')}
            </Button>
            <Button
              onClick={() => {
                document.location.href =
                  getCookie('language') === 'fa'
                    ? 'https://chatgptpeaz.ir/panel/account/user-info'
                    : `https://chatgptpeaz.ir/panel/${getCookie(
                        'language'
                      )}/account/user-info`;
              }}
              style={i18next.language === "fa" ? {fontFamily:"BYekan"}: {}}
            >
              {i18next.t('ورود به پنل کاربری')}
            </Button>
          </>
        }
      ></NavbarTwoColumns>
      <Grid container spacing={16}>
        <Grid item xs={6}>
          <LanguageSelect value={language} setValue={setLanguage} i18next={i18next} />
        </Grid>
        <Grid item xs={6}>
          <MenSelect value={mf} setValue={setMf} i18next={i18next} />
        </Grid>
        <Grid item xs={12}>
          <TextToSpeech value={text} setValue={setText} i18next={i18next}/>
        </Grid>
        {isLoading ? (
          <div
            style={{
              fontFamily: "BYekan",
              color: "white",
              marginRight: "50%",
              marginLeft: "50%",
              marginTop: "10%",
              zIndex: "24",
              textAlign: "center",
              position: "absolute",
            }}
          >
            <Loader.TailSpin />
          </div>
        ) : (
          <></>
        )}
        <Grid item xs={12}>
          <Button 
            variant="contained"
            color="primary"
            onClick={handleClick}
            style={i18next.language === "fa" ? {fontFamily:"BYekan"} : {}}
          >
            {i18next.t("Click To Speech")}
          </Button>
        </Grid>
      </Grid>
      <div id="popup1" className="pop-overlay">
        <div className="pop-popup">
          <h2></h2>
          <a className="pop-close" href="#">
            &times;
          </a>
          <div
            className="pop-content"
            style={{ textAlign: 'center', fontFamily: 'BYekan' }}
          >
            {i18next.t('لطفاً ابتدا وارد شوید')}
          </div>
          <div
            className="pop-content"
            style={{ textAlign: 'center', fontFamily: 'BYekan' }}
          >
            {i18next.t(
              'با انتخاب ورود به پنل، در بالا سمت راست، به صفحه ورود و یا ثبت نام وارد می شوید'
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const StyledApp = styled(App)`
  max-width: 640px;
  margin: 0 auto;
  padding-top: 40px;
`

export default StyledApp;
